const workdayReportMenu: any = {
  /**!!!Attenzione per i report gli id dei seguenti oggetti sono usati in core-menu.component.ts per controlli usando
   gli id quindi prima di modificare qualunque cosa di questa sezione controllare core-menu!!!
   !!!Attention for the report section, the id of the next objects are used in core-menu.component.ts for check,
   so before any edit in this section you must check before core.menu.component.ts!!!
   */
  id: "workday-user-report",
  title: "Rapportino",
  translate: "MENU.WORKDAY_USER_REPORT",
  type: "collapsible",
  icon: "trello",
  capability: "",
  children: [
    {
      id: "send-workday-user-report",
      title: "Invia rapportino",
      translate: "MENU.WORKDAY_SEND",
      type: "item",
      url: "dashboard/workday-report/user-report",
    },
    {
      id: "my-workday-user-report",
      title: "Archivio rapportini",
      translate: "ARCHIVE_REPORTS",
      type: "item",
      url: "dashboard/workday-report/my-archive",
    },
  ],
  order: 6,
};
export default workdayReportMenu;
